import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import { Language as LanguageIcon } from '@mui/icons-material';

function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('i18nextLng', lng);
    handleClose();
  };

  return (
    <>
      <Tooltip title={i18n.t('common.language')}>
        <IconButton
          color="inherit"
          onClick={handleClick}
          sx={{ ml: 1 }}
        >
          <LanguageIcon />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem
          selected={i18n.language === 'en'}
          onClick={() => handleLanguageChange('en')}
        >
          {i18n.t('common.english')}
        </MenuItem>
        <MenuItem
          selected={i18n.language === 'zh'}
          onClick={() => handleLanguageChange('zh')}
        >
          {i18n.t('common.chinese')}
        </MenuItem>
      </Menu>
    </>
  );
}

export default LanguageSwitcher;

